<div class="modal-backdrop" (click)="closeModal()">
  <div class="modal-card" (click)="$event.stopPropagation()">
    <button class="modal-close" type="button" (click)="closeModal()" aria-label="Close">×</button>
    <div class="modal-head">
      <h3>Book a consultation</h3>
      <p>Share details about your project and our team will follow up quickly.</p>
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="contact-form">
      <input formControlName="name" placeholder="Full name" />
      <input formControlName="email" placeholder="Business email" />
      <input formControlName="phone" placeholder="Phone" />
      <textarea formControlName="message" placeholder="Tell us about your project"></textarea>
      <button class="btn" type="submit" [disabled]="submitted">{{ submitted ? 'Submitting…' : 'Request consultation' }}</button>
      <p class="feedback" *ngIf="success">Your request has been captured and sent to our admin view.</p>
    </form>
  </div>
</div>
